import Moment from 'moment';
import uuid from 'uuid';
import {hasFeatureFlag} from "../../../forecast-app/shared/util/FeatureUtil";

const MIN_DATE_YEAR = 2000;
const YEAR_SPAN = 50;

// Expand section with in pixels
const GROUP_SECTION_EXPAND_WIDTH = 50;
//Group section width in pixels
const GROUP_SECTION_WIDTH = () => hasFeatureFlag('timeline_group_section_restyling') ? 351 : 270;
//How wide (in pixels) does a draggable item have to be for the drag handles to appear when you mouse over it
const DRAG_HANDLE_VISIBILITY_THRESHOLD = 54;
//Maximum display length of a name in pixels
const MAX_NAME_LENGTH = 130;
const DEFAULT_MAX_TEXT_WIDTH = 160;
//Date steps total height
const DATE_STEPS_SECTION_BACKGROUND_COLOR = '#ffffff';
const DATE_STEPS_SECTION_HEIGHT = 56;
const DATE_STEPS_SECTION_SHADOW_COLOR = '#e0e0e0';
const DATE_STEPS_SECTION_SHADOW_BLUR = 10;

// expand icon
const EXPAND_ICON_WIDTH = 10;
const EXPAND_ICON_HEIGHT = 4;

// group section
const GROUP_SECTION_MARGIN_LEFT = 24;
const GROUP_SECTION_PADDING_LEFT = 18;
const GROUP_SECTION_PADDING_LEFT_SMALL = 6.5;
const GROUP_SECTION_SPACING_LEVEL_ONE = GROUP_SECTION_MARGIN_LEFT + GROUP_SECTION_PADDING_LEFT;
const GROUP_SECTION_SPACING_LEVEL_TWO = GROUP_SECTION_SPACING_LEVEL_ONE + GROUP_SECTION_MARGIN_LEFT;
const GROUP_SECTION_SPACING_LEVEL_THREE = GROUP_SECTION_SPACING_LEVEL_TWO + GROUP_SECTION_PADDING_LEFT;
const GROUP_SECTION_SPACING_LEVEL_FOUR = GROUP_SECTION_SPACING_LEVEL_THREE + GROUP_SECTION_PADDING_LEFT;
const GROUP_SECTION_PROJECT_BACKGROUND_COLOR = '#F7F7FD';
const GROUP_SECTION_PHASES_BACKGROUND_COLOR = '#FBFBFE';
const GROUP_SECTION_TEXT_GREY = '#8E8F9F';
const GROUP_SECTION_TEXT_GREY_DARK = '#393946';
const GROUP_SECTION_TEXT_GREY_LIGHT = '#BBBBC8';
const GROUP_SECTION_PROJECT_BORDER_WIDTH = 4;
const GROUP_SECTION_BADGE_PADDING_VERTICAL = 8;
const GROUP_SECTION_BADGE_PADDING_HORIZONTAL = 16;
const GROUP_SECTION_BACKGROUND_COLOR = '#ffffff';
const GROUP_SECTION_PADDING_TOP_BOTTOM = 10;
const GROUP_SECTION_ACTION_BUTTON_SIZE = 30;
const GROUP_SECTION_ACTIONS_MENU = 15;
const GROUP_SECTION_ACTIONS_MENU_LEFT = () => hasFeatureFlag('timeline_group_section_restyling') ? 307 : 226;
const GROUP_SECTION_ACTIONS_MENU_LEFT_SCHEDULE_PEOPLE = () => hasFeatureFlag('timeline_group_section_restyling') ? 320 : 239;
const GROUP_SECTION_TARGET_PHASE_BUTTON_SIZE = 24;
const GROUP_SECTION_TARGET_PHASE_IMAGE_SIZE = 14;
const GROUP_SECTION_SHADOW_COLOR = '#a6a6a6';
const GROUP_SECTION_SHADOW_BLUR = 10;
const GROUP_SECTION_EXPAND_ICON_WIDTH = 12;
const GROUP_SECTION_EXPAND_ICON_HEIGHT = 6;

// timeline
const TIMELINE_BAR_BORDER_RADIUS = 4;
const TIMELINE_GREY_TASK_BAR_COLOR = '#D8D8E3';
const TIMELINE_BAR_PADDING_X = 10;
const TIMELINE_BACKGROUND_COLOR = '#F7F7FE';

const HEATMAP_CHECKMARK_LENIENCY_PERCENTAGE = 7;

const UTILIZATION_FORMAT = {
	HOURS: 'hours',
	PERCENTAGE: 'percentage',
};

const GROUP_TYPE = {
	PEOPLE_SCHEDULING_PERSON: 0,
	PEOPLE_SCHEDULING_PROJECT: 1,
	PEOPLE_SCHEDULING_NON_PROJECT_TIME: 2,
	PEOPLE_SCHEDULING_NON_PROJECT_TIME_TIME_REGISTRATION: 3,
	PEOPLE_SCHEDULING_TASK: 4,
	PEOPLE_SCHEDULING_PLACEHOLDER: 5,
	PEOPLE_SCHEDULING_UNASSIGNED_ROLE: 6,
	PEOPLE_SCHEDULING_UNASSIGNED_ROLE_TASK: 7,
	PROJECT_SCHEDULING_PROJECT: 8,
	PROJECT_SCHEDULING_PHASE: 9,
	PROJECT_SCHEDULING_PERSON: 10,
	PROJECT_SCHEDULING_TASK: 11,
	PROJECT_SCHEDULING_PROJECT_SUB_GROUP: 12,
	PROJECT_SCHEDULING_PROJECT_GROUP: 13,
	PEOPLE_SCHEDULING_COMPANY_UTILIZATION: 14,
	PEOPLE_SCHEDULING_NEW_PERSON: 15,
	PEOPLE_SCHEDULING_PERSON_TASKS: 16,
	PEOPLE_SCHEDULING_PERSON_ALLOCATIONS: 17,
	PROJECT_TIMELINE_HEATMAP_PERSON: 18,
	PEOPLE_SCHEDULING_LOADING: 19,
	PROJECT_SCHEDULING_LOADING: 20,
	DATE_RANGE_GROUP: 21,
	PEOPLE_SCHEDULING_PERSON_GROUP: 22,
};

const ITEM_TYPE = {
	PROJECT_SCHEDULING_PROJECT: 0,
	PROJECT_SCHEDULING_PHASE: 1,
	PROJECT_SCHEDULING_TASK: 2,
	PEOPLE_SCHEDULING_HEATMAP: 3,
	PEOPLE_SCHEDULING_PROJECT_ALLOCATION: 4,
	PROJECT_SCHEDULING_PROJECT_ALLOCATION: 5,
	PEOPLE_SCHEDULING_TASK: 6,
	PEOPLE_SCHEDULING_TIME_REGISTRATION: 7,
	PEOPLE_SCHEDULING_TASK_ALLOCATION: 8,
	PEOPLE_SCHEDULING_UNASSIGNED_TASK: 9,
	PEOPLE_SCHEDULING_UNASSIGNED_HEATMAP: 10,
	PROJECT_SCHEDULING_TASK_ALLOCATION: 11,
	PEOPLE_SCHEDULING_COMPANY_UTILIZATION: 12,
	PROJECT_SCHEDULING_TEAM_ITEM: 13,
	DATE_RANGE: 14,
};

const COMMON_IMAGE = {
	WHITE_CHECKMARK: 'white-checkmark',
	GREEN_CHECKMARK: 'green-checkmark',
	GREEN_CHECKMARK_V2: 'green-checkmark-v2',
	CONNECTED_PROJECT_BLACK: 'connected-project-black',
	CONNECTED_PROJECT_WHITE: 'connected-project-white',
	MILESTONE_ICON_BLACK: 'milestone-icon-black',
	MILESTONE_ICON_WHITE: 'milestone-icon-white',
	PROJECT_TEAM_ICON_BLACK: 'project-team-icon-black',
	PROJECT_TEAM_ICON_WHITE: 'project-team-icon-white',
	GO_TO_NEXT_WHITE: 'go-to-next-icon-white',
	GO_TO_NEXT: 'go-to-next-icon',
	GO_TO_PREVIOUS_WHITE: 'go-to-previous-icon-white',
	GO_TO_PREVIOUS: 'go-to-previous-icon',
	UNASSIGNED_HEATMAP_PERSON: 'unassigned-person-heatmap',
	HIGH_PRIORITY_FLAG_WHITE: 'high-priority-flag-white',
	DEPENDENCY_HANDLE_LEFT: 'dependency-handle-left',
	DEPENDENCY_HANDLE_RIGHT: 'dependency-handle-right',
	WARNING_ICON_RED: 'warning-icon-red',
	HEXAGON_PLUS_GREEN: 'hexagon-plus-green',
	BUG: 'bug',
	BLOCKED: 'blocked',
	WARNING: 'warning',
	FREEDAY: 'freeday',
	EXPAND: 'expand',
	COLLAPSE: 'collapse',
	EXPAND_ALL: 'expand-all',
	COLLAPSE_ALL: 'collapse-all',
	PHASES_BLACK: 'phases',
	PROJECT_TEAM_BLACK: 'project-team',
	TASK_BLACK: 'task',
	SUB_TASK_BLACK: 'sub-task',
	TASK_DONE_BLACK: 'task-done',
	TASK_NOT_STARTED: 'task-not-started',
	SUB_TASK_NOT_STARTED: 'sub-task-not-started',
	CONNECTED_PROJECT_WHITE_NEW: 'connected-project-white-new',
	TASK_DONE_GREEN_CHECKMARK: 'task-done-green-checkmark',
	TASK_BLOCKED_BLACK: 'task-blocked-black',
	TASK_BUG_BLACK: 'task-bug-black',
	TASK_HIGH_PRIORITY_BLACK: 'task-high-priority-black',
	EXPAND_GROUP_ICON: 'expand-group-icon',
	EXPAND_GROUP_CLOSED_ICON: 'expand-group-icon-closed',
};

const CURSOR = {
	DEFAULT: 'default',
	POINTER: 'pointer',
	CREATE: 'grabbing',
	RESIZE: 'ns-resize',
	RESIZE_HORIZONTAL: 'ew-resize',
};

const MOUSE_EVENT = {
	CLICK: 'click',
};

const DRAGGABLE_TYPE = {
	DATE_ONLY: 'dateOnly',
	DATE_AND_GROUP: 'dateAndGroup',
};

const ITEM_DRAG_POINT = {
	LEFT: 'left',
	CENTER: 'center',
	RIGHT: 'right',
};

//Height of the separator between collapsable section and main section in pixels
const SECTION_SPLITTER_HEIGHT = 12;

const AUTO_SCHEDULING_PERSON_WIDTH = 24;

const ITEM_POSITION_CHANGE_ANIMATION_DURATION = 200;
const GROUP_HIGHLIGHT_ANIMATION_DURATION = 400;

const measureTextCache = new Map();

const setMeasureTextData = (maxTextWidth, text, trimmedText) => {
	const width = Math.floor(maxTextWidth);
	let map = measureTextCache.get(width);
	if (!map) {
		map = new Map();
		map.set(text, trimmedText);
		measureTextCache.set(width, map);
	} else {
		map.set(text, trimmedText);
	}
};

const getMeasureTextData = (maxTextWidth, text) => {
	const outerMap = measureTextCache.get(Math.floor(maxTextWidth));
	if (!outerMap) return null;
	return outerMap.get(text);
};

const getCanvasTimelineDateFromMoment = momentDate => {
	if (!momentDate.isValid()) {
		return 0;
	}
	return momentDate.diff(Moment().year(MIN_DATE_YEAR).startOf('year'), 'days', false);
};

const getMomentFromCanvasTimelineDate = canvasTimelineDate => {
	return Moment().year(MIN_DATE_YEAR).startOf('year').add(canvasTimelineDate, 'days', false);
};

const canvasTimelineDateCache = new Map();

const createCanvasTimelineDate = (year, month, day) => {
	let yearCache = canvasTimelineDateCache.get(year);
	if (!yearCache) {
		yearCache = new Map();
		canvasTimelineDateCache.set(year, new Map());
	}
	let monthCache = yearCache.get(month);
	if (!monthCache) {
		monthCache = new Map();
		yearCache.set(month, new Map());
	}
	let canvasTimelineDate = monthCache.get(day);
	if (!canvasTimelineDate) {
		canvasTimelineDate = getCanvasTimelineDateFromMoment(Moment({y: year, M: month - 1, d: day}));
		monthCache.set(day, canvasTimelineDate);
	}
	return canvasTimelineDate;
};

const areItemDatesValid = (itemStartDate, itemEndDate) => {
	//The dates passed here should be dates already converted to canvas timeline dates through getCanvasTimelineDateFromMoment of createCanvasTimelineDate
	return itemStartDate && itemEndDate && itemEndDate >= itemStartDate;
};

const getTextColor = (backgroundColor, lightOption = '#ffffff', darkOption = '#2a2a2a') => {
	if (!backgroundColor) return '#535353';
	let brightness = 255;
	const brightnessThreshold = 165;
	try {
		const c = parseInt(backgroundColor.slice(1), 16);
		const r = c >> 16;
		const g = (c >> 8) & 0x00ff;
		const b = c & 0x0000ff;

		brightness = 0.2126 * r + 0.7152 * g + 0.0722 * b;
	} catch (e) {}
	return brightness < brightnessThreshold ? lightOption : darkOption;
};

const drawRectangle = (context, x, y, width, height, options = {}) => {
	const backgroundColor = options.backgroundColor || '#ffffff';
	const backgroundOpacity = options.backgroundOpacity !== undefined ? options.backgroundOpacity : 1;
	const borderThickness = options.borderThickness || 0;
	const borderColor = options.borderColor || '#ffffff';
	//Do not allow the sum of top/bottom border radius to exceed width
	const maxBorderRadius =
		width /
		(((options.borderTopLeftRadius || options.borderRadius) && (options.borderTopRightRadius || options.borderRadius)) || ((options.borderBottomLeftRadius || options.borderRadius) && (options.borderBottomRightRadius || options.borderRadius))
			? 2
			: 1);
	const borderTopLeftRadius = Math.min(options.borderTopLeftRadius || options.borderRadius || 0, maxBorderRadius);
	const borderTopRightRadius = Math.min(options.borderTopRightRadius || options.borderRadius || 0, maxBorderRadius);
	const borderBottomLeftRadius = Math.min(options.borderBottomLeftRadius || options.borderRadius || 0, maxBorderRadius);
	const borderBottomRightRadius = Math.min(options.borderBottomRightRadius || options.borderRadius || 0, maxBorderRadius);

	const clearBeforeDrawing = options.clearBeforeDrawing || false;
	const isCornerTopRightCutOff = options.isCornerTopRightCutOff || false;
	const isCornerBottomRightCutOff = options.isCornerBottomRightCutOff || false;
	const isCornerBottomLeftCutOff = options.isCornerBottomLeftCutOff || false;
	const isCornerTopLeftCutOff = options.isCornerTopLeftCutOff || false;

	context.strokeStyle = borderColor;
	context.lineWidth = borderThickness;

	const lineOffset = borderThickness / 2;

	let triangleBase, triangleHeight;
	if (isCornerTopRightCutOff || isCornerTopLeftCutOff || isCornerBottomRightCutOff || isCornerBottomLeftCutOff) {
		// in case the cut off corners are overlapping (meaning they do not fit in the rectangle) share the with of the rectangle between the cut off corners
		const maxCornerWidth = width / ((isCornerTopLeftCutOff && isCornerTopRightCutOff) || (isCornerBottomLeftCutOff && isCornerBottomRightCutOff) ? 2 : 1);
		const angle = 30; // Degrees
		triangleBase = maxCornerWidth > 12 ? 12 : maxCornerWidth;
		triangleHeight = triangleBase * Math.tan((angle * Math.PI) / 180);
	}

	context.beginPath();
	context.moveTo(x + lineOffset + borderTopLeftRadius, y + lineOffset);

	// Top Right Corner
	if (borderTopRightRadius) {
		context.lineTo(x + width - lineOffset - borderTopRightRadius, y + lineOffset);
		context.arcTo(x + width - lineOffset, y + lineOffset, x + width - lineOffset, y + lineOffset + borderTopRightRadius, borderTopRightRadius);
	} else if (isCornerTopRightCutOff) {
		context.lineTo(x + width - lineOffset - triangleBase, y + lineOffset);
		context.lineTo(x + width - lineOffset, y + lineOffset + triangleHeight);
	} else {
		context.lineTo(x + width - lineOffset, y + lineOffset);
	}

	// Bottom Right Corner
	if (borderBottomRightRadius) {
		context.lineTo(x + width - lineOffset, y + height - lineOffset - borderBottomRightRadius);
		context.arcTo(x + width - lineOffset, y + height - lineOffset, x + width - lineOffset - borderBottomRightRadius, y + height - lineOffset, borderBottomRightRadius);
	} else if (isCornerBottomRightCutOff) {
		context.lineTo(x + width - lineOffset, y + height - lineOffset - triangleHeight);
		context.lineTo(x + width - lineOffset - triangleBase, y + height - lineOffset);
	} else {
		context.lineTo(x + width - lineOffset, y + height - lineOffset);
	}

	// Bottom Left Corner
	if (borderBottomLeftRadius) {
		context.lineTo(x + lineOffset + borderBottomLeftRadius, y + height - lineOffset);
		context.arcTo(x + lineOffset, y + height - lineOffset, x + lineOffset, y + height - lineOffset - borderBottomLeftRadius, borderBottomLeftRadius);
	} else if (isCornerBottomLeftCutOff) {
		context.lineTo(x + lineOffset + triangleBase, y + height - lineOffset);
		context.lineTo(x + lineOffset, y + height - lineOffset - triangleHeight);
	} else {
		context.lineTo(x + lineOffset, y + height - lineOffset);
	}

	// Top Left Corner
	if (borderTopLeftRadius) {
		context.lineTo(x + lineOffset, y + borderTopLeftRadius);
		context.arcTo(x + lineOffset, y + lineOffset, x + lineOffset + borderTopLeftRadius, y + lineOffset, borderTopLeftRadius);
	} else if (isCornerTopLeftCutOff) {
		context.lineTo(x + lineOffset, y + triangleHeight);
		context.lineTo(x + lineOffset + triangleBase, y + lineOffset);
	} else {
		context.lineTo(x + lineOffset, y);
	}

	if (clearBeforeDrawing) {
		context.fillStyle = '#ffffff';
		context.fill();
	}
	context.fillStyle = backgroundColor;
	if (backgroundOpacity !== 1) {
		context.globalAlpha = backgroundOpacity;
	}
	context.fill();
	context.globalAlpha = 1;
	//Draw border if there should be one
	if (borderThickness) {
		context.stroke();
	}
};

function drawHexagon(context, x, y, width, fillColor, fillOpacity, strokeColor, strokeWidth) {
	const fill = fillColor !== '';
	strokeWidth = strokeWidth || 2;

	context.fillStyle = fillColor;
	context.strokeStyle = strokeColor;
	context.lineWidth = strokeWidth;
	context.globalAlpha = fillOpacity || 1;

	let hexHeight,
		hexRadius,
		hexRectangleHeight,
		hexRectangleWidth,
		hexagonAngle = 0.523598776, // 30 degrees in radians
		sideLength = width / 2;

	hexHeight = Math.sin(hexagonAngle) * sideLength;
	hexRadius = Math.cos(hexagonAngle) * sideLength;
	hexRectangleHeight = sideLength + 2 * hexHeight;
	hexRectangleWidth = 2 * hexRadius;

	context.beginPath();
	context.moveTo(x + hexRadius, y);
	context.lineTo(x + hexRectangleWidth, y + hexHeight);
	context.lineTo(x + hexRectangleWidth, y + hexHeight + sideLength);
	context.lineTo(x + hexRadius, y + hexRectangleHeight);
	context.lineTo(x, y + sideLength + hexHeight);
	context.lineTo(x, y + hexHeight);
	context.closePath();

	fill ? context.fill() : context.stroke();
}

function hexToRgb(hex, alpha) {
	hex = hex.replace('#', '');
	var r = parseInt(hex.length === 3 ? hex.slice(0, 1).repeat(2) : hex.slice(0, 2), 16);
	var g = parseInt(hex.length === 3 ? hex.slice(1, 2).repeat(2) : hex.slice(2, 4), 16);
	var b = parseInt(hex.length === 3 ? hex.slice(2, 3).repeat(2) : hex.slice(4, 6), 16);
	if (alpha) {
		return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
	} else {
		return 'rgb(' + r + ', ' + g + ', ' + b + ')';
	}
}

//Drawing the arrow up/down which shows whether or not the group is expanded
const drawExpansionIcon = (context, x, y, width, height, options = {}) => {
	//x, y, width, height are values describing the group, not measurements of the icon itself
	const xCenter = hasFeatureFlag("timeline_group_section_restyling")
		? x + GROUP_SECTION_SPACING_LEVEL_ONE + width
		: x + width - EXPAND_ICON_WIDTH / 2 - 16; //16 margin right
	const yCenter = y + height / 2;
	const xDiff = EXPAND_ICON_WIDTH / 2;
	const yDiff = EXPAND_ICON_HEIGHT / 2;
	context.strokeStyle = getTextColor(options.backgroundColor); //Will return dark version if color is not provided
	context.lineWidth = 2;
	context.beginPath();
	if (options.expanded) {
		context.moveTo(xCenter - xDiff, yCenter + yDiff);
		context.lineTo(xCenter, yCenter - yDiff);
		context.lineTo(xCenter + xDiff, yCenter + yDiff);
	} else {
		context.moveTo(xCenter - xDiff, yCenter - yDiff);
		context.lineTo(xCenter, yCenter + yDiff);
		context.lineTo(xCenter + xDiff, yCenter - yDiff);
	}
	context.stroke();
};

//Drawing 1px grey line on the bottom and on the right
const drawBorderLines = (context, x, y, width, height, useGreyColor, customColor, borderWidth = 1) => {
	context.fillStyle = customColor ? customColor : useGreyColor ? '#ebebee' : '#ffffff';
	context.fillRect(x, y + height - 1, width, borderWidth);
	context.fillStyle = useGreyColor ? '#ebebee' : '#ffffff';
	context.fillRect(width - 1, y, 1, height);
};

const drawBorder = (context, x, y, length, vertical, color = '#ebebee', borderWidth = 1) => {
	context.fillStyle = color;
	context.fillRect(x, y + borderWidth - 1, vertical ? borderWidth : length, vertical ? length : borderWidth);
};

const drawBackground = (context, x, y, width, height, useGreyColor, customColor) => {
	context.fillStyle = customColor ? customColor : useGreyColor ? TIMELINE_BACKGROUND_COLOR : '#ffffff';
	context.fillRect(x, y, width, height);
};

/*
 * If a name is too long, this will return the longest text that fits
 * within the maximum name length.
 */
const getTrimmedText = (context, text = '', maxWidth = DEFAULT_MAX_TEXT_WIDTH) => {
	const cachedText = getMeasureTextData(maxWidth, text);
	if (cachedText) return cachedText;
	//The context that is passed to this function should have font size and style already specified before calling this function
	let substring = text;
	if (context.measureText(substring).width <= maxWidth) {
		setMeasureTextData(maxWidth, text, text);
		return text;
	}
	//Find the maximum number of characters that can fit within the given maxWidth
	let min = 0;
	let max = text.length;
	//Find the middle between text length and 0
	//If the text does not fit, then we know that the text has to be shorter than that middle
	//If the text fits, then we know it can be equal to or longer than the middle value
	//Repeat until we find the exact position
	while (min < max) {
		const mid = (min + max) >>> 1; //convert to int and divide by 2
		substring = text.substring(0, mid);
		const substringWidth = context.measureText(substring).width;
		if (substringWidth < maxWidth) {
			min = mid + 1;
		} else {
			max = mid;
		}
	}
	const trimmedText = substring.length ? substring + '...' : '';
	setMeasureTextData(maxWidth, text, trimmedText);
	return trimmedText;
};

const drawArrows = (context, textColor, x, y, previousArrowIcon, nextArrowIcon, extramarginY, extraMarginX) => {
	if (previousArrowIcon && nextArrowIcon) {
		context.drawImage(previousArrowIcon, x + (extraMarginX ? extraMarginX : 0), y + (extramarginY ? extramarginY : 0), 6, 12);
		context.drawImage(nextArrowIcon, x + (11 + (extraMarginX ? extraMarginX : 0)), y + (extramarginY ? extramarginY : 0), 6, 12);
	}
};

const createCacheCanvas = (width, height) => {
	const {devicePixelRatio} = window;
	let canvas;
	if (window.OffscreenCanvas) {
		canvas = new OffscreenCanvas(width * devicePixelRatio, height * devicePixelRatio);
	} else {
		canvas = document.createElement('canvas');
		canvas.height = height * devicePixelRatio;
		canvas.width = width * devicePixelRatio;
	}
	const context = canvas.getContext('2d');
	context.scale(devicePixelRatio, devicePixelRatio);
	return canvas;
};

let dayData = null;

const getDayData = (minDate, maxDate) => {
	if (dayData) {
		return dayData;
	}
	dayData = [];
	const loopDate = minDate;
	while (loopDate.isBefore(maxDate)) {
		const moment = loopDate.clone();
		dayData.push({
			moment,
			isoWeekday: moment.isoWeekday(),
			weekday: moment.weekday(),
			daysInMonth: moment.daysInMonth(),
			daysInQuarter: moment.clone().endOf('quarter').diff(moment.clone().startOf('quarter'), 'days') + 1,
			isoWeek: moment.isoWeek(),
			week: moment.week(),
			dayOfMonth: moment.date(),
			dayOfQuarter: moment.diff(moment.clone().startOf('quarter'), 'days') + 1,
			dayOfYear: moment.dayOfYear(),
			daysInYear: moment.isLeapYear() ? 366 : 365,
		});
		loopDate.add(1, 'day');
	}
	return dayData;
};

/**
 * Lightweight version of dayData, without the moment date. This is so it can be parsed to
 * web workers as parameter. Web workers don't accept functions as input, so class objects,
 * like moment, is no possible. The other reason is that web workers don't share global scope
 * with the main app, so each web worker would have to generate the daydata again, which is
 * a heavy operation (measured in seconds)
 *
 * This is also one of the things we should look at, at some point. Should we really generate
 * so much data up front, instead of on demand. We spend 1+ second on it, and it's most likely
 * <1% that is used.
 */

let dayDataLight = null;
const getDayDataLight = (minDate, maxDate) => {
	if (dayDataLight !== null) {
		return dayDataLight;
	}
	dayDataLight = getDayData(minDate, maxDate).map(data => ({
		isoWeekday: data.isoWeekday,
		weekday: data.weekday,
		daysInMonth: data.daysInMonth,
		daysInQuarter: data.daysInQuarter,
		isoWeek: data.isoWeek,
		week: data.week,
		dayOfMonth: data.dayOfMonth,
		dayOfYear: data.dayOfYear,
		dayOfQuarter: data.dayOfQuarter,
		daysInYear: data.daysInYear,
	}));
	return dayDataLight;
};

const getWeekdaysBetweenDates = (startDate, endDate, dayData = null, excludeStartDay, excludeEndDay) => {
	const weekdays = [0, 0, 0, 0, 0, 0, 0];
	for (let i = excludeStartDay ? 1 : 0; i < endDate - startDate + (excludeEndDay ? 0 : 1); i++) {
		const date = startDate + i;
		if (dayData === null) {
			dayData = getDayData();
		}
		weekdays[dayData[date].isoWeekday - 1]++;
	}
	return weekdays;
};

const getMinutesInWeekdays = (entity, weekdays) => {
	const dayNames = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
	return weekdays.reduce((total, weekday, index) => total + entity[dayNames[index]] * weekday, 0);
};

const isDateWithinPersonStartEndDate = (person, canvasDate) => {
	return (person.startDate === null || person.startDate <= canvasDate) && (person.endDate === null || person.endDate >= canvasDate);
};

const getHolidayDates = (person, data, personWorkingMinutes, dayDataArray = dayData) => {
	const holidayCalendar = person.holidayCalendarId
		? data.holidayCalendars.find(holidayCalendar => person.holidayCalendarId === holidayCalendar.id)
		: data.company.defaultHolidayCalendarId
		? data.holidayCalendars.find(holidayCalendar => data.company.defaultHolidayCalendarId === holidayCalendar.id)
		: data.holidayCalendars.length === 1
		? data.holidayCalendars[0]
		: null;
	const holidaysIncludingDaysOff = [];
	const holidaysExcludingDaysOff = [];
	if (holidayCalendar) {
		for (const holidayCalendarEntry of data.holidayCalendarEntries.filter(holidayCalendarEntry => holidayCalendarEntry.holidayCalendarId === holidayCalendar.id)) {
			const holidayDate = createCanvasTimelineDate(holidayCalendarEntry.year, holidayCalendarEntry.month, holidayCalendarEntry.day);
			// Ignore out-of-range holidays
			if (!dayDataArray[holidayDate]) continue;
			if (holidaysIncludingDaysOff.includes(holidayDate)) continue;
			holidaysIncludingDaysOff.push(holidayDate);
			if (!personWorkingMinutes[dayDataArray[holidayDate].isoWeekday - 1]) continue;
			holidaysExcludingDaysOff.push(holidayDate);
		}
	}
	return {holidaysIncludingDaysOff, holidaysExcludingDaysOff};
};

const doGetAllGroupsOfType= (groups, groupType) => {
	let matchingGroups = [];
	if (groups) {
		for (const group of groups) {
			if (group.groupType === groupType) {
				matchingGroups.push(group);
			} else if (group.groups) {
				matchingGroups = matchingGroups.concat(doGetAllGroupsOfType(group.groups, groupType));
			}
		}
	}
	return matchingGroups;
};

const getAllGroupsOfType = (groups, groupType) => {
	return doGetAllGroupsOfType(groups, groupType);
};

const getPersonGroups = (groups) => {
	return getAllGroupsOfType(groups, GROUP_TYPE.PEOPLE_SCHEDULING_PERSON);
};

let simulationMode = false;

const setSimulationMode = mode => (simulationMode = mode);
const isSimulationMode = () => simulationMode;

let timestampCorrelationId,
	timestampDataLoaded,
	timestampCanvasRendered,
	timestampLabel = null;
const setTimestampCorrelationId = () => {
	timestampCorrelationId = uuid.v4();
	timestampDataLoaded = null;
	timestampCanvasRendered = null;
	timestampLabel = null;
};
const setTimestampDataLoaded = () => {
	timestampDataLoaded = performance.now();
};
const setTimestampLabel = label => (timestampLabel = label);
const setTimestampCanvasRendered = () => {
	if (!timestampCanvasRendered) {
		timestampCanvasRendered = performance.now();
	}
};
const hasTimestampCanvasRendered = () => !!timestampCanvasRendered;
const getCanvasRenderDuration = () => (timestampCanvasRendered - timestampDataLoaded) / 1000;
const getTimestampCorrelationId = () => timestampCorrelationId;
const getTimestampLabel = () => timestampLabel;

const getFontHeight = (canvasContext) => {
	const fontParts = canvasContext.font.split(" ");
	const fontSizePixels = fontParts.find(part => part.includes("px"));

	if (fontSizePixels) {
		// remove "px" and parse to integer
		return parseInt(fontSizePixels.slice(0, fontSizePixels.length - 2));
	}

	// default
	return 13 * 1.2;
};

module.exports = {
	UTILIZATION_FORMAT,
	GROUP_SECTION_EXPAND_WIDTH,
	GROUP_SECTION_WIDTH,
	DRAG_HANDLE_VISIBILITY_THRESHOLD,
	MAX_NAME_LENGTH,
	GROUP_TYPE,
	ITEM_TYPE,
	CURSOR,
	MOUSE_EVENT,
	MIN_DATE_YEAR,
	YEAR_SPAN,
	SECTION_SPLITTER_HEIGHT,
	COMMON_IMAGE,
	createCanvasTimelineDate,
	getCanvasTimelineDateFromMoment,
	getMomentFromCanvasTimelineDate,
	areItemDatesValid,
	getTextColor,
	drawRectangle,
	drawExpansionIcon,
	drawHexagon,
	getTrimmedText,
	drawBorderLines,
	drawBackground,
	drawArrows,
	hexToRgb,
	createCacheCanvas,
	ITEM_POSITION_CHANGE_ANIMATION_DURATION,
	GROUP_HIGHLIGHT_ANIMATION_DURATION,
	DATE_STEPS_SECTION_HEIGHT,
	DRAGGABLE_TYPE,
	getDayData,
	getDayDataLight,
	ITEM_DRAG_POINT,
	getWeekdaysBetweenDates,
	isDateWithinPersonStartEndDate,
	getMinutesInWeekdays,
	setSimulationMode,
	isSimulationMode,
	AUTO_SCHEDULING_PERSON_WIDTH,
	HEATMAP_CHECKMARK_LENIENCY_PERCENTAGE,
	getHolidayDates,
	setTimestampCorrelationId,
	setTimestampDataLoaded,
	setTimestampLabel,
	setTimestampCanvasRendered,
	getCanvasRenderDuration,
	hasTimestampCanvasRendered,
	getTimestampLabel,
	getTimestampCorrelationId,
	getPersonGroups,
	GROUP_SECTION_MARGIN_LEFT,
	GROUP_SECTION_PADDING_LEFT,
	GROUP_SECTION_SPACING_LEVEL_ONE,
	GROUP_SECTION_SPACING_LEVEL_TWO,
	GROUP_SECTION_PROJECT_BACKGROUND_COLOR,
	GROUP_SECTION_PHASES_BACKGROUND_COLOR,
	GROUP_SECTION_TEXT_GREY,
	GROUP_SECTION_SPACING_LEVEL_THREE,
	GROUP_SECTION_SPACING_LEVEL_FOUR,
	GROUP_SECTION_TEXT_GREY_DARK,
	GROUP_SECTION_PADDING_LEFT_SMALL,
	GROUP_SECTION_TEXT_GREY_LIGHT,
	EXPAND_ICON_WIDTH,
	EXPAND_ICON_HEIGHT,
	GROUP_SECTION_PROJECT_BORDER_WIDTH,
	GROUP_SECTION_BACKGROUND_COLOR,
	GROUP_SECTION_PADDING_TOP_BOTTOM,
	GROUP_SECTION_ACTION_BUTTON_SIZE,
	GROUP_SECTION_ACTIONS_MENU,
	GROUP_SECTION_BADGE_PADDING_VERTICAL,
	GROUP_SECTION_BADGE_PADDING_HORIZONTAL,
	GROUP_SECTION_ACTIONS_MENU_LEFT,
	getFontHeight,
	drawBorder,
	TIMELINE_BAR_BORDER_RADIUS,
	TIMELINE_GREY_TASK_BAR_COLOR,
	TIMELINE_BAR_PADDING_X,
	GROUP_SECTION_TARGET_PHASE_BUTTON_SIZE,
	DATE_STEPS_SECTION_BACKGROUND_COLOR,
	DATE_STEPS_SECTION_SHADOW_COLOR,
	DATE_STEPS_SECTION_SHADOW_BLUR,
	GROUP_SECTION_SHADOW_COLOR,
	GROUP_SECTION_SHADOW_BLUR,
	GROUP_SECTION_TARGET_PHASE_IMAGE_SIZE,
	GROUP_SECTION_EXPAND_ICON_WIDTH,
	GROUP_SECTION_EXPAND_ICON_HEIGHT,
	TIMELINE_BACKGROUND_COLOR,
	GROUP_SECTION_ACTIONS_MENU_LEFT_SCHEDULE_PEOPLE,
};
